"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CallsOutlineIcon = void 0;
var React = __importStar(require("react"));
function CallsOutlineIcon(props) {
  var _a, _b, _c, _d;
  return React.createElement("svg", __assign({
    width: (_a = props.width) !== null && _a !== void 0 ? _a : 24,
    height: (_b = props.height) !== null && _b !== void 0 ? _b : 24,
    xmlns: "http://www.w3.org/2000/svg",
    fill: (_c = props.fill) !== null && _c !== void 0 ? _c : "#191C22",
    viewBox: (_d = props.viewBox) !== null && _d !== void 0 ? _d : "0 0 24 24"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.339 7.81a12.057 12.057 0 0 1-1.44-4.838A1.056 1.056 0 0 0 8.847 2h-4.71a1.056 1.056 0 0 0-1.05.948C3.029 3.508 3 4.07 3 4.638 3 13.675 10.325 21 19.36 21c.569 0 1.132-.029 1.692-.087a1.056 1.056 0 0 0 .948-1.05v-4.71a1.056 1.056 0 0 0-.973-1.052 12.056 12.056 0 0 1-4.837-1.44 1.056 1.056 0 0 0-1.366.312l-.933 1.307A11.143 11.143 0 0 1 9.72 10.11l1.306-.933a1.056 1.056 0 0 0 .313-1.366Zm-1.45.383L7.8 9.686l.651 1.145a12.603 12.603 0 0 0 4.719 4.718l1.145.652 1.493-2.09a13.517 13.517 0 0 0 4.732 1.41v3.973c-.39.03-.782.045-1.178.045-8.23 0-14.9-6.671-14.9-14.9 0-.396.014-.79.045-1.179h3.972c.176 1.651.654 3.255 1.412 4.733Z"
  }));
}
exports.CallsOutlineIcon = CallsOutlineIcon;